export function AddVideo(organizationID: number, ID: number, videoID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}/videos/${videoID}`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/video-collections`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/video-collections`;
}

export function RemoveVideo(organizationID: number, ID: number, videoID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}/videos/${videoID}`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}`;
}

export function ShowVideos(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}/videos`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-collections/${ID}`;
}

